export default __webpack_public_path__ + "static/media/(14).b58332f1.JPG";